(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["koliza-collection-automne"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.ka a[href^="#"]');
    if (!link) return;

    var section = link.closest('.ka');
    var targetId = link.getAttribute('href');
    var target = section.querySelector(targetId);
    if (!target) return;

    event.preventDefault();

    var header = document.querySelector('.site-header, .header-wrapper');
    var headerHeight = header ? header.getBoundingClientRect().height : 0;
    var targetTop = target.getBoundingClientRect().top + window.scrollY - headerHeight - 16;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    window.scrollTo({
      top: Math.max(targetTop, 0),
      behavior: reducedMotion ? 'auto' : 'smooth'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skinova-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('skinova-product')) {
  customElements.define('skinova-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const opts = {signal:this.abort.signal};
      const select = this.querySelector('[data-variant]');
      const main = this.querySelector('[data-main-image]');
      const add = this.querySelector('[data-add]');
      const qty = this.querySelector('[name="quantity"]');
      const subscription = this.dataset.requiresPlan === 'true';
      const change = () => {
        const option = select.selectedOptions[0];
        this.querySelector('[data-price-output]').textContent = option.dataset.price;
        const compare = this.querySelector('[data-compare-output]');
        compare.textContent = option.dataset.compare;
        compare.hidden = !option.dataset.compare;
        add.disabled = option.dataset.available !== 'true' || subscription;
        add.textContent = option.dataset.available === 'true' ? add.dataset.label : add.dataset.soldOut;
        qty.min = option.dataset.min || '1'; qty.step = option.dataset.step || '1';
        if(option.dataset.max) qty.max=option.dataset.max; else qty.removeAttribute('max');
        qty.value=qty.min;
        if(option.dataset.image && main.querySelector('img')) { const img=main.querySelector('img'); img.removeAttribute('srcset'); img.src=option.dataset.image; img.alt=option.dataset.imageAlt || ''; }
        const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
      };
      select.addEventListener('change', change, opts);
      this.querySelectorAll('[data-thumb]').forEach(button => button.addEventListener('click', () => {
        const image = button.querySelector('img'); if(!image) return;
        const copy = image.cloneNode(true); copy.loading='eager'; copy.sizes='(min-width: 990px) 50vw, 100vw';
        main.replaceChildren(copy);
        this.querySelectorAll('[data-thumb]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
      }, opts));
      const sticky=this.querySelector('[data-sticky]');
      if(sticky) {this.observer=new IntersectionObserver(([entry])=>{sticky.hidden=entry.isIntersecting || entry.boundingClientRect.bottom>=0;});this.observer.observe(this.querySelector('.sv-offer'));}
    }
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.ready=false;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skinovav2-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('skinovav2-product')) {
  customElements.define('skinovav2-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const opts = {signal:this.abort.signal};
      const select = this.querySelector('[data-variant]');
      if (!select) return;
      const main = this.querySelector('[data-main-image]');
      const add = this.querySelector('[data-add]');
      const subscription = this.dataset.requiresPlan === 'true';
      const change = () => {
        const option = select.selectedOptions[0];
        add.disabled = option.dataset.available !== 'true' || subscription;
        add.textContent = option.dataset.available === 'true' ? add.dataset.label : add.dataset.soldOut;
        if(option.dataset.image && main.querySelector('img')) { const img=main.querySelector('img'); img.removeAttribute('srcset'); img.src=option.dataset.image; img.alt=option.dataset.imageAlt || ''; }
        if(this.dataset.updateUrl === 'true') { const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url); }
      };
      select.addEventListener('change', change, opts);
      const thumbs = [...this.querySelectorAll('[data-thumb]')];
      const prev = this.querySelector('[data-gallery-prev]');
      const next = this.querySelector('[data-gallery-next]');
      const SIZES = '(min-width: 990px) 50vw, 100vw';
      const preload = (button) => {
        if(!button || button.dataset.preloaded) return;
        const image = button.querySelector('img'); if(!image) return;
        button.dataset.preloaded = '1';
        const img = new Image();
        img.sizes = SIZES; if(image.srcset) img.srcset = image.srcset; img.src = image.currentSrc || image.src;
      };
      const preloadAround = (index) => {
        preload(thumbs[(index + 1) % thumbs.length]);
        preload(thumbs[(index - 1 + thumbs.length) % thumbs.length]);
      };
      let seq = 0;
      const show = (button) => {
        const image = button.querySelector('img'); if(!image) return;
        const token = ++seq;
        thumbs.forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
        button.scrollIntoView({block:'nearest',inline:'center',behavior:'smooth'});
        const copy = image.cloneNode(true);
        copy.loading='eager'; copy.decoding='async'; copy.sizes=SIZES; copy.classList.add('sv2-entering');
        const ready = copy.decode ? copy.decode().catch(()=>{}) : Promise.resolve();
        ready.then(() => {
          if(token !== seq) return;
          const current = main.querySelector('img:not(.sv2-leaving)');
          main.prepend(copy);
          requestAnimationFrame(() => requestAnimationFrame(() => {
            copy.classList.remove('sv2-entering');
            if(current) { current.classList.add('sv2-leaving'); setTimeout(() => current.remove(), 450); }
          }));
          preloadAround(thumbs.indexOf(button));
        });
      };
      const step = (delta) => {
        if(thumbs.length < 2) return;
        const index = thumbs.findIndex(item=>item.getAttribute('aria-pressed')==='true');
        show(thumbs[(index + delta + thumbs.length) % thumbs.length]);
      };
      thumbs.forEach(button => {
        button.addEventListener('click', () => show(button), opts);
        button.addEventListener('pointerenter', () => preload(button), opts);
      });
      const active = thumbs.findIndex(item=>item.getAttribute('aria-pressed')==='true');
      if(thumbs.length > 1) { const start = () => preloadAround(active < 0 ? 0 : active); 'requestIdleCallback' in window ? requestIdleCallback(start) : setTimeout(start, 800); }
      if(prev && next && thumbs.length > 1) {
        prev.hidden = false; next.hidden = false;
        prev.addEventListener('click', () => step(-1), opts);
        next.addEventListener('click', () => step(1), opts);
      }
      let startX = null;
      main.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, {passive:true, signal:this.abort.signal});
      main.addEventListener('touchend', e => {
        if(startX === null) return;
        const delta = e.changedTouches[0].clientX - startX; startX = null;
        if(Math.abs(delta) > 40) step(delta < 0 ? 1 : -1);
      }, {passive:true, signal:this.abort.signal});
      const sticky=this.querySelector('[data-sticky]');
      if(sticky) {this.observer=new IntersectionObserver(([entry])=>{sticky.hidden=entry.isIntersecting || entry.boundingClientRect.bottom>=0;});this.observer.observe(this.querySelector('.sv2-offer'));}
    }
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.ready=false;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skinovav2-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('skinovav2-reviews')) {
  customElements.define('skinovav2-reviews', class extends HTMLElement {
    connectedCallback() {
      if(this.ready || this.dataset.carousel !== 'true') return;
      this.ready=true; this.abort=new AbortController(); const opts={signal:this.abort.signal};
      const track=this.querySelector('[data-track]'); const cards=[...this.querySelectorAll('[data-review]')];
      const previous=this.querySelector('[data-prev]'),next=this.querySelector('[data-next]');
      this.querySelector('[data-controls]').hidden=false;
      const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
      const step=()=>cards.length>1?cards[1].offsetLeft-cards[0].offsetLeft:track.clientWidth;
      const update=()=>{const max=track.scrollWidth-track.clientWidth;previous.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft>=max-2;this.querySelector('[data-position]').textContent=Math.min(cards.length,Math.round(track.scrollLeft/Math.max(1,step()))+1);};
      const move=direction=>track.scrollBy({left:direction*step(),behavior:reduced()?'auto':'smooth'});
      previous.addEventListener('click',()=>move(-1),opts);next.addEventListener('click',()=>move(1),opts);
      track.addEventListener('scroll',update,{...opts,passive:true});
      track.addEventListener('keydown',event=>{if(event.target!==track)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}if(event.key==='Home'||event.key==='End'){event.preventDefault();track.scrollTo({left:event.key==='Home'?0:track.scrollWidth,behavior:reduced()?'auto':'smooth'});}},opts);
      this.resize=new ResizeObserver(update);this.resize.observe(track);
      document.addEventListener('shopify:block:select',event=>{const card=event.target.closest('[data-review]');if(card && this.contains(card))track.scrollTo({left:card.offsetLeft-cards[0].offsetLeft,behavior:'auto'});},opts);
      update();
    }
    disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();this.ready=false;}
  });
}

  } catch(e) { console.error(e); }
})();
})();
